/**
 * <TutorApplicationOutcome> — la candidature est finie : où elle en est (organism).
 *
 * L'ancien `ApplicationFinishedScreen` : « CANDIDATURE TERMINÉE ! », une illustration, et Zoé qui dit
 * la suite — « nous étudions ta candidature » tant qu'elle est en attente, « tu as reçu un email avec
 * ton évaluation » une fois le verdict rendu, qu'il soit un refus ou une évaluation favorable pas
 * encore validée. Le verdict lui-même (la note, les domaines jugés « aptes 1ʳᵉ–Tle ») ne s'affiche
 * pas dans l'app : il part par e-mail, et la validation fait du compte un tuteur, qui ne voit plus
 * cet écran.
 */
import React from "react"

import { type UITutorApplicationStatus } from "../../../ports/primary/ui/types/tutorCandidature"
import { ChampionAvatar } from "../../atoms/Avatar/ChampionAvatar"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../../molecules/Card"

const TUTOR_APPLICATION_OUTCOME_TEXTS = {
    title: "Candidature terminée !",
    pending: "Merci ! Nous étudions ta candidature. En général, nous envoyons une réponse en quelques semaines.",
    answered: "Tu as reçu un email avec ton évaluation.",
}

/** Zoé, en grand : c'est elle qui parle, et il n'y a rien d'autre sur la carte. */
const OUTCOME_CHAMPION_SIZE = 96

export type TutorApplicationOutcomeProps = {
    /** `pending`, `rejected` ou `evaluated` — un `draft` n'a pas d'issue. */
    status: Exclude<UITutorApplicationStatus, "draft">
    testID?: string
}

export function TutorApplicationOutcome(props: TutorApplicationOutcomeProps) {
    const { status, testID } = props

    return (
        <Card p="6" testID={testID}>
            <Stack gap="4" align="center">
                <ChampionAvatar name="zoe" size={OUTCOME_CHAMPION_SIZE} />
                <Text size="text-2xl" weight="extrabold" color="text-primary" center accessibilityRole="header">
                    {TUTOR_APPLICATION_OUTCOME_TEXTS.title}
                </Text>
                <Text size="text-md" color="text-primary" center>
                    {status === "pending"
                        ? TUTOR_APPLICATION_OUTCOME_TEXTS.pending
                        : TUTOR_APPLICATION_OUTCOME_TEXTS.answered}
                </Text>
            </Stack>
        </Card>
    )
}
